import { __assign } from "tslib";
import { testDataCreator } from '@wix/answers-lib';
import { createOverviewStats } from '../../callcenter';
import { createTeamPerformanceAnalyticsFilterDto } from '../team-performance';
import { ChatBreakdownType } from './domain';
var timeZone = 'UTC';
export var createChatAnalyticsFilterDto = testDataCreator({
    startDate: '1988-31-10',
    endDate: '1988-31-10',
    timeZone: timeZone
});
export var createGetChatOverviewDto = testDataCreator(function () { return (__assign({ metrics: [] }, createTeamPerformanceAnalyticsFilterDto())); });
export var createChatOverviewStatsComparison = testDataCreator(function () { return ({
    value: createOverviewStats(),
    compared: createOverviewStats()
}); });
export var createChatHistogramDto = testDataCreator(function () { return (__assign({ histogramInterval: 2, terms: [], breakdown: ChatBreakdownType.ALL }, createChatAnalyticsFilterDto())); });
export var createChatCumulativeDto = testDataCreator(function () { return (__assign({ terms: [], breakdown: ChatBreakdownType.ALL }, createChatAnalyticsFilterDto())); });
//# sourceMappingURL=builders.js.map